module.exports = __webpack_public_path__ + "c299b572fad59ed8ae5f4844a2372b40.svg";